module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-banner"
    }
  }, [_c('swiper', {
    ref: "myBannerSwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/Banner_a_Euroregio.jpg')"
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/1_Toulouse.jpg')"
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/2_Montpellier.jpg')"
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/3_Barcelona.jpg')"
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "banner-slide"
  }, [_c('div', {
    staticClass: "banner-slide-cover",
    staticStyle: {
      "background-image": "url('/static/img/4_Palma.jpg')"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b1017f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-euroregio/components/banner-slider/banner-slider.vue
// module id = 313
// module chunks = 0